import { TOUR_TRANSLATIONS } from "../translations"

export const getSosDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="sos-details-filters"]',
            title: t.sosDetailsFilters.title,
            content: t.sosDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="sos-details-share-chart"]',
            title: t.sosDetailsShareChart.title,
            content: t.sosDetailsShareChart.content,
        },
        {
            target: '[data-tour="sos-details-table"]',
            title: t.sosDetailsTable.title,
            content: t.sosDetailsTable.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.sosDetailsEvolution.title,
            content: t.sosDetailsEvolution.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'sos-details-table', closeOnLeave: true },
        },
    ]
}
